import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { delay } from 'rxjs/operators';

@Component({
    selector: 'app-visual-guide-tester',
    templateUrl: './visual-guide-tester.component.html',
    styleUrls: ['./visual-guide-tester.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VisualGuideTesterComponent implements OnInit {
  step1 = false;
  step2 = false;
  step3$ = new BehaviorSubject(false);
  step4 = false;
  showStep3$ = this.step3$.pipe(delay(1000));

  constructor() {}

  ngOnInit(): void {}
}
